/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candid_Trite_Midge_IntendInputs */

const fr_candid_trite_midge_intend = /** @type {(inputs: Candid_Trite_Midge_IntendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouve tous tes paiements ici.`)
};

/**

* @param {Candid_Trite_Midge_IntendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const candid_trite_midge_intend = /** @type {((inputs?: Candid_Trite_Midge_IntendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candid_Trite_Midge_IntendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_candid_trite_midge_intend(inputs)
});